const HIGH_RISK_NATIONALITY_FRAGMENTS = [
  'severna korea',
  'severni korea',
  'north korea',
  'korejska demokraticka',
  'democratic people',
  'democratic republic of korea',
  'kldr',
  'dprk',
  'iran',
  'myanmar',
  'mjanmarsko',
  'barma',
  'burma',
] as const;

function normalizeForNationalityMatch(value: string): string {
  return value.trim().normalize('NFD').replaceAll(/\p{M}/gu, '').toLowerCase().replaceAll(/\s+/g, ' ');
}

export function isHighRiskNationality(value: string): boolean {
  const normalized = normalizeForNationalityMatch(value);
  if (!normalized) {
    return false;
  }

  return HIGH_RISK_NATIONALITY_FRAGMENTS.some((fragment) => {
    const normalizedFragment = normalizeForNationalityMatch(fragment);
    return normalized.includes(normalizedFragment);
  });
}
